<template>
    <div class="c-why-choose-us">
        <div class="c-why-choose-us__title">
            <h2 class="mb-3">
                {{ content.title }}
            </h2>
        </div>

        <div
            v-if="$mq === 'lg' || $mq === 'xlg'"
            class="c-why-choose-us__content"
        >
            <y-row>
                <y-col
                    v-for="(album, index) in content.albums"
                    :key="`choose-us-${index}`"
                    sm="12"
                    md="6"
                    lg="4"
                >
                    <div class="c-why-choose-us__content__card">
                        <div class="c-why-choose-us__content__card__title">
                            <div class="title">
                                <h3>
                                    {{ album.title }}
                                </h3>
                            </div>
                            <div class="img">
                                <img
                                    :src="album.link"
                                    :alt="album.title"
                                >
                            </div>
                        </div>
                        <div class="c-why-choose-us__content__card__text">
                            <p>
                                {{ album.description }}
                            </p>
                        </div>
                    </div>
                </y-col>
            </y-row>
        </div>

        <div
            v-else
            class="c-why-choose-us__slide-show-wrapper"
        >
            <y-slideshow
                ref="Slideshow"
                height="auto"
                slides-per-view="1.2"
                pagination="1"
            >
                <y-slide
                    v-for="(album, index) in content.albums"
                    :key="`responsive-choose-us-${index}`"
                >
                    <div class="pa-4">
                        <div class="c-why-choose-us__content__card">
                            <div class="c-why-choose-us__content__card__title">
                                <div class="title">
                                    <h3>
                                        {{ album.title }}
                                    </h3>
                                </div>
                                <div class="img">
                                    <img
                                        :src="album.link"
                                        :alt="album.title"
                                    >
                                </div>
                            </div>
                            <div class="c-why-choose-us__content__card__text">
                                <p>
                                    {{ album.description }}
                                </p>
                            </div>
                        </div>
                    </div>
                </y-slide>
            </y-slideshow>
        </div>
    </div>
</template>

<script>
    import { YSlide, YSlideshow } from '@groot-components/all';

    export default {
        name      : 'WhyChooseUs',
        components: { YSlide, YSlideshow },
        props     : {
            content: Object,
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
